// Tasks domain — per-matter + firm-wide task manager.
import { API } from './_client';

export const tasks = {
  list: (opts = {}) => API.get('/tasks', { params: opts }).then((r) => r.data),
  me: () => API.get('/tasks/me').then((r) => r.data),
  get: (id) => API.get(`/tasks/${id}`).then((r) => r.data),
  create: (payload) => API.post('/tasks', payload).then((r) => r.data),
  update: (id, patch) => API.patch(`/tasks/${id}`, patch).then((r) => r.data),
  remove: (id) => API.delete(`/tasks/${id}`).then((r) => r.data),
};
